import { ConfigService } from '@core/config.service';
import * as i0 from "@angular/core";
import * as i1 from "../../../core/config.service";
/**
 * Ported over from universa-layout
 */
var CdnService = /** @class */ (function () {
    function CdnService(configService) {
        this.configService = configService;
    }
    CdnService.prototype.getCDNUrl = function (url) {
        var cdnList = this.configService.config['cdnBaseUrls'];
        var nameMapping = null;
        if (!url) {
            return '';
        }
        if (!cdnList || !cdnList.length) {
            return url;
        }
        // do not process full URLs
        if (/^https?:\/\//.test(url)) {
            return url;
        }
        url = this.stripLeadingSlash(url);
        var cdnIndex = (url.length) % (cdnList.length);
        var cdnPrefix = this.stripTrailingSlash(cdnList[cdnIndex]);
        // apply mapping
        var mappingFor = nameMapping || {};
        var mappedUrl = mappingFor[url] || url;
        url = cdnPrefix + '/' + mappedUrl;
        return url;
    };
    CdnService.prototype.stripTrailingSlash = function (url) {
        if (url.charAt(url.length - 1) === '/') {
            url = url.substr(0, url.length - 1);
        }
        return url;
    };
    CdnService.prototype.stripLeadingSlash = function (url) {
        if (url.charAt(0) === '/') {
            url = url.substr(1);
        }
        return url;
    };
    CdnService.ngInjectableDef = i0.ɵɵdefineInjectable({ factory: function CdnService_Factory() { return new CdnService(i0.ɵɵinject(i1.ConfigService)); }, token: CdnService, providedIn: "root" });
    return CdnService;
}());
export { CdnService };
